/**
 * теперь этот файл/поток будет кодироваться в UTF-8
 */

export const BlogListFilter = {
    name: 'BlogListFilter',
    props: {
        tags: {
            type: Object,
            required: true
        },
        selected: {
            type: String
        }
    },
    template: `

        
        <div class="tabs">
        
            
                <button
                    class="tabs__button"
                    v-for="tag in tags"
                     :key="tag.CODE"
                     @click="$emit('selectedTag', tag.CODE)"
                     :class="{
                     'active': selected === tag.CODE
                     }">
                      {{ tag.NAME }}
                </button>
         
        
        </div>

    `
}